import React, {useEffect, useState} from 'react'
import SimpleDropDownPicker from "../../../../../../forms/Dropdown/SimpleDropDownPicker";
import {statesOptions, fcsSupportedCountriesOptions} from "../../../../../../../constants/constantVariables";
import strings from "../../../../../../../strings";
import DropDownPicker from "../../../../../../forms/ReactHookForm/DropDown/DropDownPicker";
import {getJurisdictionList} from "../../../../../../../actions/applicants";
import Grid from "@material-ui/core/Grid";

const JurisdictionPicker = ({ control, error, helperText, setValue, labelField, valueField, fullWidth, preSelectedValue}) => {

    const [jurisdictionCountry, setJurisdictionCountry] = useState('')
    const [filingJurisdictionState, setFilingJurisdictionState] = useState('')
    const [jurisdictionOptions, setJurisdictionOptions] = useState([])
    const [jurisdictionOptionsLoading, setJurisdictionOptionsLoading] = useState(false)

    // When country changes, reset state and jurisdiction
    useEffect(() => {
        setFilingJurisdictionState('')
        setJurisdictionOptions([])
        if (setValue) {
            setValue('jurisdictionId', '')
        }
    }, [jurisdictionCountry, setValue])

    // When state changes, fetch jurisdictions
    useEffect(() => {
        if (jurisdictionCountry && filingJurisdictionState) {
            setJurisdictionOptionsLoading(true)
            getJurisdictionList({countryCode: jurisdictionCountry, state: filingJurisdictionState})().then((response) => {
                setJurisdictionOptions(response || [])
                setJurisdictionOptionsLoading(false)
            })
        } else {
            setJurisdictionOptions([])
        }
    }, [filingJurisdictionState, jurisdictionCountry])

    return (
        <>
            <Grid item xs={4}>
                <SimpleDropDownPicker
                    options={fcsSupportedCountriesOptions}
                    label={strings.LABEL.COUNTRY}
                    name={'jurisdictionCountryPicker'}
                    selectedValue={jurisdictionCountry}
                    setSelectedValue={setJurisdictionCountry}
                    labelField={'label'}
                    valueField={'value'}
                    fullWidth={fullWidth}
                />
            </Grid>
            <Grid item xs={4}>
                <SimpleDropDownPicker
                    options={jurisdictionCountry ? (statesOptions[jurisdictionCountry] || []) : []}
                    label={strings.LABEL.JURISDICTION_STATE}
                    name={'filingJurisdictionState'}
                    selectedValue={filingJurisdictionState}
                    setSelectedValue={setFilingJurisdictionState}
                    labelField={'label'}
                    valueField={'value'}
                    fullWidth={fullWidth}
                />
            </Grid>
            <Grid item xs={4}>
                {!jurisdictionOptionsLoading && (
                    <DropDownPicker control={control}
                                    error={error}
                                    helperText={helperText}
                                    options={jurisdictionOptions}
                                    label={strings.APPLICANT.UCCFILING.JURISDICTION}
                                    name={'jurisdictionId'}
                                    preSelectedValue={preSelectedValue}
                                    labelField={labelField}
                                    valueField={valueField}
                                    setValue={setValue}
                                    fullWidth={fullWidth}
                    />
                )}
            </Grid>
        </>
    )
}

export default JurisdictionPicker